import Vue from 'vue'
import vuetify from '@/plugins/vuetify';

import VuetifyToast from '@/plugins/toast'
Vue.use(VuetifyToast, { vuetify })


